module.exports = __webpack_public_path__ + "static/241129_9M_2024_Announcement_Financial_Results-284aa7d5ae559cce1e78d0d79a5ae96e.pdf";